<template>
  <p id="question-text" class="text-center text-2xl py-8 px-0">
    {{ question.properties.content.text_question[getLocale] ?? '' }}
    <span v-if="getHoverInfo" class="relative inline-block">
      <i class="fas fa-info-circle group-hover:text-[var(--color-orange)]
        transition-transform group-hover:scale-125">
        <font-awesome-icon icon="fa-circle-question"/>
      </i>
      <span class="hidden w-36 bg-[var(--color-orange)] text-white group-hover:visible text-center
        rounded-md py-1 px-0 absolute bottom-full left-1/2 -ml-20">
        {{ getHoverInfo }}</span>
    </span>
  </p>
  <p class="text-center font-bold px-0 py-2 text-lg">
    {{ $t('KssChampionUserListQuestion.beforeNumber') }}
    <span style='color: var(--color-orange);'>{{ getSelectedUserCount }}</span>
    {{ $t('KssChampionUserListQuestion.afterNumber', { count: getSelectedUserCount }) }}
  </p>
  <div class="w-full max-w-[600px] max-h-[400px] my-0 mx-auto py-5 px-4 break-all overflow-y-auto">
    <kss-champion-profile v-for="(member, i) in involvedUsers" :key="member._id"
                          @click.prevent="select(i)" :is-selected="member.isChecked"
                          :name="member.name"
                          :picture-url="member.picture_profile?.small"/>
  </div>
  <div class="flex flex-col items-center relative box-border sm:flex-row justify-center my-4">
    <button type="button" name="update" :disabled="submitDisabled"
        class="text-xl text-white bg-[var(--color-orange)] hover:bg-[var(--color-fulvous)]
        rounded-full h-10 w-60 sm:mx-2 my-2"
        @click.prevent="handleChoice(false)">
      {{ $t('KssChampionUserListQuestion.choose') }}
    </button>
    <button type="button" name="update" :disabled="submitDisabled"
        class="text-xl text-[var(--color-black)] bg-white border-2 border-[var(--color-orange)]
        hover:bg-[var(--color-fulvous)] rounded-full h-10 w-60 sm:mx-2 my-2"
        @click.prevent="handleChoice(true)">
      {{ $t('KssChampionUserListQuestion.maybeNextTime') }}
    </button>
  </div>
</template>

<script>
import KssChampionProfile from '@/components/Home/QuestionnaireComponent/KssChampionProfile.vue';
import { isAnswerMissingForQuestionnaire } from '@/helpers/questionnaireValidation';

export default {
  name: 'KssChampionUserListQuestion',
  components: { KssChampionProfile },
  data() {
    return {
      question: this.$store.state.questionnaireManagement.selectedQuestion,
      involvedUsers: this.$store.getters.getInvolvedUsers,
      submitDisabled: false,
    };
  },
  computed: {
    getLocale() {
      return this.$i18n.locale;
    },
    getHoverInfo() {
      return this.question.properties.content.description?.[this.getLocale];
    },
    getSelectedUserCount() {
      return this.$store.state.questionnaireManagement.multipleChoose
        - this.$store.getters.getInvolvedUsers.filter((el) => el.isChecked).length;
    },
    getForceInput() {
      return this.$store.state.questionnaireManagement.forceInput;
    },
    getAnswer() {
      return this.$store.state.questionnaireManagement.answer;
    },
  },
  methods: {
    select(index) {
      this.$store.commit('selectInvolvedUser', index);
    },
    async handleChoice(skipAnswering) {
      try {
        this.submitDisabled = true;
        if (this.getForceInput) {
          if (isAnswerMissingForQuestionnaire(this.getAnswer)) {
            this.$toast.add({
              severity: 'error',
              summary: this.$t('ToastComponent.questionnaire.noInputErr'),
              detail: '',
              life: 3000,
            });
            this.submitDisabled = false;
            return;
          }
        }
        if (skipAnswering) {
          this.$store.commit('setAnswer', undefined);
        }
        await this.$store.dispatch('setNextQuestion');
        this.submitDisabled = false;
      } catch (error) {
        this.submitDisabled = false;
        this.$toast.add({
          severity: 'error',
          summary: error.response.data.message,
          detail: '',
          life: 3000,
        });
      }
    },
  },
  mounted() {
    this.$store.commit('setShowNextButton', false);
  },
  unmounted() {
    this.$store.commit('setShowNextButton', true);
  },
};
</script>
